module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('h1', {
    staticClass: "Prelims-head"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Jacquie Large (TOOT) loves poems, stories, and anything that will make you smile. Her poems, especially, are about her take on life, the fun and drama along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Her poems have sometimes made it into her local paper "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Border Post")]), _vm._v(", and last year she ran a poetry class at her local art gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Her poems are fun, light-hearted and tricky. Some of them have happened to her and this makes them special!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c554d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398418653_EPUB.vue
// module id = 57
// module chunks = 0